var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingBrowser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 273,
    viewBox: "0 0 492 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M491.073 0.736328H0.5V272.736H491.073V0.736328Z",
    fill: "#fed304"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M491.073 31.604H0.5V272.737H491.073V31.604Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1825 15.4062C25.1825 18.1568 22.1515 20.6017 17.8217 20.6017C13.4918 20.6017 10.4609 18.4624 10.4609 15.4062C10.4609 12.6557 13.4918 10.2107 17.8217 10.2107C22.1515 10.2107 25.1825 12.6557 25.1825 15.4062Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.493 15.4062C55.493 18.1568 52.4621 20.6017 48.1322 20.6017C44.2354 20.6017 40.7715 18.4624 40.7715 15.4062C40.7715 12.6557 43.8024 10.2107 48.1322 10.2107C52.4621 10.5163 55.493 12.6557 55.493 15.4062Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8016 15.4062C85.8016 18.1568 82.7707 20.6017 78.4408 20.6017C74.5439 20.6017 71.0801 18.4624 71.0801 15.4062C71.0801 12.6557 74.111 10.2107 78.4408 10.2107C82.7707 10.5163 85.8016 12.6557 85.8016 15.4062Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M322.211 24.5743H120.006C113.079 24.5743 107.883 20.6013 107.883 16.017C107.883 11.1271 113.512 7.45972 120.006 7.45972H321.778C328.705 7.45972 333.901 11.4327 333.901 16.017C334.334 20.6013 328.706 24.5743 322.211 24.5743Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M460.765 24.5743H365.075C358.147 24.5743 352.951 20.6013 352.951 16.017C352.951 11.1271 358.58 7.45972 365.075 7.45972H460.765C467.692 7.45972 472.888 11.4327 472.888 16.017C473.321 20.6013 467.692 24.5743 460.765 24.5743Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.676 98.7363C243.915 98.7363 242.373 100.278 242.373 102.04V123.181C242.373 124.943 243.915 126.485 245.676 126.485C247.438 126.485 248.98 124.943 248.98 123.181V102.04C248.98 100.278 247.438 98.7363 245.676 98.7363Z",
    fill: "#fed304"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.676 176.476C243.915 176.476 242.373 178.017 242.373 179.779V200.921C242.373 202.683 243.915 204.224 245.676 204.224C247.438 204.224 248.98 202.683 248.98 200.921V179.999C248.98 178.017 247.438 176.476 245.676 176.476Z",
    fill: "#fed304"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.226 148.287H274.085C272.323 148.287 270.781 149.828 270.781 151.59C270.781 153.352 272.323 154.894 274.085 154.894H295.226C296.988 154.894 298.53 153.352 298.53 151.59C298.53 149.828 296.988 148.287 295.226 148.287Z",
    fill: "#fed304"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.789 151.59C220.789 149.828 219.248 148.287 217.486 148.287H196.344C194.583 148.287 193.041 149.828 193.041 151.59C193.041 153.352 194.583 154.894 196.344 154.894H217.486C219.248 154.894 220.789 153.352 220.789 151.59Z",
    fill: "#fed304"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.137 169.208C266.815 167.887 264.613 167.887 263.292 169.208C261.97 170.53 261.97 172.732 263.292 174.053L278.267 189.029C279.588 190.35 281.791 190.35 283.112 189.029C284.433 187.707 284.433 185.505 283.112 184.184L268.137 169.208Z",
    fill: "#fed304"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.08 114.152C211.759 112.831 209.557 112.831 208.235 114.152C206.914 115.473 206.914 117.676 208.235 118.997L223.21 133.972C224.532 135.294 226.734 135.294 228.055 133.972C229.377 132.651 229.377 130.449 228.055 129.127L213.08 114.152Z",
    fill: "#fed304"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.21 169.208L208.235 184.184C206.914 185.505 206.914 187.707 208.235 189.029C209.557 190.35 211.759 190.35 213.08 189.029L228.055 174.053C229.377 172.732 229.377 170.53 228.055 169.208C226.734 167.887 224.532 167.887 223.21 169.208Z",
    fill: "#fed304"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.137 133.972L283.112 118.997C284.433 117.676 284.433 115.473 283.112 114.152C281.791 112.831 279.588 112.831 278.267 114.152L263.292 129.127C261.97 130.449 261.97 132.651 263.292 133.972C264.613 135.294 266.815 135.294 268.137 133.972Z",
    fill: "#fed304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBrowser);
export default __webpack_public_path__ + "static/media/loading_browser.43cee9f9e3c95f23a21bd4c496290429.svg";
export { ForwardRef as ReactComponent };